import CardResult from "components/ui/CardResult";
import Filter from "components/ui/Filter";
import Spinner from "components/ui/Spinner";
import StepNav from "components/ui/StepNav";
import StepTitle from "components/ui/StepTitle";
import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import { FaExclamation } from "react-icons/fa6";
import { useNavigate } from "react-router";
import { getFinalResult } from "services/realization.service";
import { categories, RealizationResultItem } from "types/realization";
import { StageIds } from "utils/constants";

const Result = () => {
  const navigate = useNavigate();

  const { user, currentStep } = useAuth();
  const [loading, setLoading] = useState(false);

  const [myRealizations, setMyRealizations] = useState<RealizationResultItem[]>(
    []
  );
  const [categories, setCategories] = useState<categories[]>([]);
  const [realizations, setRealizations] = useState<RealizationResultItem[]>([]);
  const [filteredRealizations, setFilteredRealizations] = useState<
    RealizationResultItem[]
  >([]);

  const [filter, setFilter] = useState<{
    category?: string;
    searchTerm?: string;
    prefix?: number;
  }>({});

  useEffect(() => {
    async function getData() {
      setLoading(true);
      try {
        if (!!user) {
          const data = await getFinalResult(user);

          const items = data
            ? data.others.flatMap((item) => item.realizations)
            : [];

          setMyRealizations(data?.mine || []);

          let newCategories = data
            ? data.others.map((item) => {
                return {
                  name: `${item.categoryName}(${item.realizations.length})`,
                  _id: item.categoryName,
                };
              })
            : [];

          newCategories.unshift({
            name: `Todas (${items.length})`,
            _id: "-1",
          });

          setRealizations(items);

          setFilteredRealizations(filteredData(items, newCategories[0]._id));

          setCategories(newCategories);
        }
      } catch (e) {
      } finally {
        setLoading(false);
      }
    }
    getData();
  }, [user]);

  const filteredData = (
    data: RealizationResultItem[],
    category?: string,
    title?: string
  ) => {
    let filteredData = data.filter((item) => {
      let categoryMatch =
        category && category !== "-1" ? item.categoria === category : true;
      // Função para remover acentos
      const normalize = (str: string) =>
        str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase();

      let titleMatch = title
        ? normalize(item.title).includes(normalize(title)) ||
          normalize(item.name_dependency).includes(normalize(title)) ||
          normalize(item.categoria).includes(normalize(title))
        : true;
      return categoryMatch && titleMatch;
    });

    return filteredData;
  };

  useEffect(() => {
    let result = filteredData(realizations, filter.category, filter.searchTerm);

    setFilteredRealizations(result);
  }, [filter]);

  useEffect(() => {
    if (currentStep?._id !== StageIds.STAGE_ENTREGA) {
      navigate("/");
    }
  }, [currentStep]);

  return (
    <>
      {loading ? (
        <div className="flex items-start justify-center w-full h-screen">
          <div className="flex flex-col">
            <Spinner />
            <span className="text-center text-blue-bb">Carregando...</span>
          </div>
        </div>
      ) : (
        <>
          <StepNav currentStep={5} activeSubStep={1} />
          <div className="mt-28">
            <div className="px-4 md:px-0">
              <h2 className="text-blue-bb-3 text-[40px] font-title font-bold mb-6">
                Resultado Final do Prêmio BB 2025
              </h2>
              <p className="text-blue-bb-4 text-[22px]">
                Conheça as 15 iniciativas premiadas em 1º, 2º e 3º lugar de cada
                uma das 5 categorias do prêmio!
              </p>
            </div>

            {myRealizations.length > 0 && (
              <>
                <div className="">
                  <StepTitle title={"Minhas iniciativas premiadas"} />
                </div>

                <div className="grid-cols-1 mx-4 md:grid md:mx-auto gap-7 content">
                  {myRealizations.map(
                    (item: RealizationResultItem, index: number) => (
                      <CardResult data={item} position={item.position} />
                    )
                  )}
                </div>
              </>
            )}

            <div className="mt-28">
              <div className="flex items-end justify-end">
                <div className="w-full">
                  <Filter
                    categories={categories}
                    enableCategoryFilter={true}
                    placeholderField={"O que você procura"}
                    onChange={(key, value) => {
                      setFilter((prev) => ({ ...filter, [key]: value }));
                    }}
                  />
                </div>
              </div>
            </div>

            {filteredRealizations.length === 0 ? (
              <div className="flex items-center justify-center my-5">
                <FaExclamation />
                <p className="text-lg font-semibold text-gray-bb-1">
                  Não há realizações para esse filtro!
                </p>
              </div>
            ) : (
              <>
                <div className="grid-cols-1 mx-4 md:grid md:mx-auto gap-7 content">
                  {filteredRealizations.map(
                    (item: RealizationResultItem, index: number) => (
                      <CardResult data={item} position={item.position} />
                    )
                  )}
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Result;
